/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
/* eslint-disable react/no-multi-comp */

import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useParams } from 'react-router-dom';

import {
  Box,
  Breadcrumbs,
  Button,
  InputAdornment,
  List,
  ListItem,
  ListItemText,
  ListSubheader,
  Modal,
  TextField,
} from '@mui/material';

// Material helpers
import { Typography, Grid2 } from '@mui/material';

// Shared layouts
import { Dashboard as DashboardLayout } from 'layouts';

// Custom components
import { GridMeter } from './components';
import { Paper } from 'components';

// Component styles
import styles from './styles';
import { makeStyles } from '@mui/styles';
import { useIntl } from 'react-intl';
import theme from 'theme';
import { ArrowOutward, Search } from '@mui/icons-material';
import { searchData } from 'js/actions/meterActions';
import { EmptyTable } from 'components/EmptyTable';
const useStyles = makeStyles(styles);

export default function Meter(props) {
  const intl = useIntl();
  const classes = useStyles();
  const dispatch = useDispatch();
  const { corpId } = useParams();
  const user = useSelector((state) => state.user.user);
  const { data } = useSelector((state) => state.meters);
  const [searchOpen, setSearchOpen] = useState(false);
  const [searchWord, setSearchWord] = useState('');
  const [nodes, setNodes] = useState([]);
  const [groups, setGroups] = useState([]);
  const [charges, setCharges] = useState([]);

  useEffect(() => {
    if (data) {
      const newNodes = [];
      const newGroups = [];
      const newCharges = [];

      Object.entries(data).forEach(([nodeId, nodeValue]) => {
        if (!nodeValue.name) return;

        newNodes.push({ id: nodeId, name: nodeValue.name });

        Object.entries(nodeValue).forEach(([groupId, groupValue]) => {
          if (['id', 'name'].includes(groupId) || !groupValue?.name) return;

          newGroups.push({ id: groupId, name: groupValue.name, nodeId });

          Object.entries(groupValue).forEach(([chargeId, chargeValue]) => {
            if (['id', 'name'].includes(chargeId) || !chargeValue?.name) return;

            newCharges.push({
              id: chargeId,
              name: chargeValue.name,
              rate_horary: chargeValue.rate_horary,
              type_energy: chargeValue.type_energy,
              groupId,
              nodeId,
            });
          });
        });
      });

      setNodes(newNodes);
      setGroups(newGroups);
      setCharges(newCharges);
    }
  }, [data]);

  const corporative = useSelector(
    user.adser == 1
      ? (state) => state.user.corporative
      : (state) => state.user.user.corporative
  );

  const corporatives = useSelector((state) => state.corporatives.corporatives);

  const getBanner = () => {
    let corporativeTMP = corporative;

    if (user.adser === 1) {
      corporativeTMP = corporatives.find((m) => {
        return m.id == corporative.id;
      });
    } else {
      corporativeTMP = corporative;
    }

    if (corporativeTMP == null) {
      return '';
    }

    return (
      <Paper style={{ padding: 10, marginTop: 15 }}>
        <Grid2
          alignItems="center"
          container={true}
          direction="row"
          justify="flex-start"
          style={{ position: 'relative' }}
        >
          <div className={classes.imageWrapper}>{getImage()}</div>

          <div>
            <Typography className={classes.title} variant="h4">
              {corporativeTMP.name}
            </Typography>

            <Typography className={classes.data} variant="h5">
              {corporativeTMP.city} - {corporativeTMP.state}
            </Typography>

            <Typography className={classes.data}>
              {intl.formatMessage({ id: 'app.meters.banner.contact' })}:{' '}
              {corporativeTMP.contact.name}
            </Typography>

            <Typography className={classes.data}>
              {intl.formatMessage({ id: 'app.meters.banner.phone' })}:{' '}
              {corporativeTMP.contact.tel}
            </Typography>
          </div>
          <div style={{ position: 'absolute', top: '0', right: '0' }}>
            <Link to={`/dashboard/${corporativeTMP.id}`} state={corporativeTMP}>
              <Button color="secondary" variant="contained">
                Dashboard de Bienvenida
              </Button>
            </Link>
          </div>
        </Grid2>
      </Paper>
    );
  };

  useEffect(() => {
    if (searchOpen) {
      dispatch(searchData(corpId));
    }
  }, [searchOpen]);

  const getImage = () => {
    if (corporative != null) {
      if (corporative.logo != null && corporative.logo != '') {
        return (
          <img alt="Product" className={classes.image} src={corporative.logo} />
        );
      } else {
        return (
          <img
            alt="Product"
            className={classes.image}
            src="images/logo-metimur.png"
          />
        );
      }
    }
  };

  return (
    <DashboardLayout chargeName={corporative.name} title={'Medidores'}>
      <div className={classes.root}>
        <Box
          display="flex"
          flexDirection="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Typography
            style={{ color: '#A53693', marginBottom: theme.spacing(2) }}
            variant="h2"
          >
            {intl.formatMessage({ id: 'app.meters.nav.meters' })}s
          </Typography>
          {/* <Button
            variant="contained"
            color="secondary"
            startIcon={<Search />}
            onClick={() => setSearchOpen(true)}
          >
            Buscar
          </Button> */}
        </Box>
        {getBanner()}
        <div className={classes.content}>
          <GridMeter corporative_id={corpId} />
        </div>
      </div>
      <Modal
        open={searchOpen}
        onClose={() => setSearchOpen(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          position={'absolute'}
          top={'50%'}
          left={'50%'}
          bgcolor={'background.paper'}
          borderRadius={2}
          boxShadow={24}
          p={2}
          width={'50%'}
          height={'fit-content'}
          maxHeight={'650px'}
          sx={{
            transform: 'translate(-50%, -50%)',
          }}
          display={'flex'}
          flexDirection={'column'}
          justifyContent={'space-between'}
          alignItems={'center'}
          gap={2}
        >
          <TextField
            variant="outlined"
            fullWidth={true}
            placeholder="Buscar Cargas..."
            value={searchWord}
            onChange={(e) => setSearchWord(e.target.value)}
            slotProps={{
              input: {
                startAdornment: (
                  <InputAdornment position="start">
                    <Search />
                  </InputAdornment>
                ),
              },
            }}
          />
          <Box
            width={'100%'}
            height={'fit-content'}
            overflow={'auto'}
            maxHeight={'600px'}
            minHeight={'350px'}
          >
            {searchWord === '' ? (
              <EmptyTable text="Buscador de Cargas" />
            ) : (
              <List
                sx={{
                  width: '100%',
                  bgcolor: 'background.paper',
                  position: 'relative',
                  overflow: 'auto',
                  padding: 0,
                }}
              >
                {charges
                  .filter((charge) =>
                    charge.name.toLowerCase().includes(searchWord.toLowerCase())
                  )
                  .map((charge) => {
                    const group = groups.find((g) => g.id === charge.groupId);
                    const node = nodes.find((n) => n.id === charge.nodeId);

                    if (!group || !node) {
                      return (
                        <EmptyTable
                          text="No se encontraron resultados"
                          key={'1'}
                        />
                      );
                    }

                    return (
                      <Link
                        to={
                          charge?.type_energy?.id_energy === 2
                            ? `/dashboardSolarCharge/group/${group.id}/charge/${charge.id}`
                            : `/chargeDashboard/group/${group.id}/charge/${charge.id}`
                        }
                        state={{
                          corporative: corporative,
                          charge: charge,
                          meter: node,
                          group: group,
                          concentrator: corpId,
                        }}
                        style={{ textDecoration: 'none', color: '#A53693' }}
                        key={charge.id}
                      >
                        <ListItem
                          sx={{
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            border: '1px solid rgb(225,225,225)',
                            padding: 2,
                            marginBottom: 1,
                            bgcolor: 'rgb(245,245,245)',
                            borderRadius: 2,
                            cursor: 'pointer',
                            '&:hover': {
                              backgroundColor: 'rgb(225,225,225)',
                            },
                          }}
                        >
                          <Breadcrumbs separator="›" sx={{ fontSize: 14 }}>
                            <Typography color="text.primary">
                              {node.name}
                            </Typography>
                            <Typography color="text.secondary">
                              {group.name}
                            </Typography>
                            <Typography
                              color="common.secondary"
                              fontWeight={500}
                            >
                              {charge.name}
                            </Typography>
                          </Breadcrumbs>
                          <Button
                            variant="outlined"
                            size="small"
                            color="secondary"
                            sx={{
                              minWidth: 'auto',
                              padding: '0 !important',
                              margin: '0 !important',
                            }}
                          >
                            <ArrowOutward fontSize="small" />
                          </Button>
                        </ListItem>
                      </Link>
                    );
                  })}
              </List>
            )}
          </Box>
          <Button
            variant="contained"
            color="secondary"
            onClick={() => setSearchOpen(false)}
            fullWidth={true}
          >
            Cerrar
          </Button>
        </Box>
      </Modal>
    </DashboardLayout>
  );
}
